import React from "react";
import { Box } from "@mui/material";

// Template70: Portada Nueva York (guia-ny Page1)
// Copia de guia-ny Page1.jsx con datos de NY y rutas /images/ny/
const Template70 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
}) => {
	const base = "/images/ny/";
	const backgroundImage =
		page?.images?.[0]?.src ||
		page?.canvasImages?.find((img) => img.id === "portada-fondo")?.imageUrl ||
		`${base}portada-fondo.png`;
	const backgroundStickersImage =
		page?.canvasImages?.find((img) => img.id === "background-stickers")
			?.imageUrl || `${base}portada-stickers.png`;
	const portadaImage =
		page?.canvasImages?.find((img) => img.id === "portada-central")?.imageUrl ||
		`${base}portada.png`;
	const logoImage =
		page?.canvasImages?.find((img) => img.id === "logo")?.imageUrl ||
		`${base}logo.png`;
	const headerText = page?.texts?.[0]?.content || "GUÍA DE VIAJE";

	const parseSVGText = () => {
		const svgContent = page?.texts?.[1]?.content || "";
		if (!svgContent) {
			return {
				text1: "7 días",
				text2: "en Nueva York",
				fill1: "#59c3d8",
				stroke1: "#0c2d32",
				fill2: "#59c3d8",
				stroke2: "#0c2d32",
			};
		}
		const parser = new DOMParser();
		const doc = parser.parseFromString(svgContent, "image/svg+xml");
		const texts = doc.querySelectorAll("text");
		return {
			text1: texts[0]?.textContent?.trim() || "7 días",
			text2: texts[1]?.textContent?.trim() || "en Nueva York",
			fill1: texts[0]?.getAttribute("fill") || "#59c3d8",
			stroke1: texts[0]?.getAttribute("stroke") || "#0c2d32",
			fill2: texts[1]?.getAttribute("fill") || "#59c3d8",
			stroke2: texts[1]?.getAttribute("stroke") || "#0c2d32",
		};
	};

	const { text1, text2, fill1, stroke1, fill2, stroke2 } = parseSVGText();

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				width: "100%",
				height: "100%",
				backgroundColor: backgroundColor || "#d2ebf0",
				borderRadius: "12px",
				overflow: "hidden",
				position: "relative",
				"& *:not(svg):not(text)": {
					fontFamily: (fontFamily || '"Poppins", sans-serif') + "!important",
				},
			}}
		>
			<div
				style={{
					backgroundColor: headerBackgroundColor || "#59c3d8",
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontFamily: fontFamily || '"Poppins", sans-serif',
					fontSize: "14px",
					fontWeight: 700,
				}}
			>
				{headerText}
			</div>
			<img
				src={logoImage}
				alt="logo"
				style={{
					width: 100,
					position: "absolute",
					right: 0,
					top: 14,
					zIndex: 100,
				}}
			/>

			<div
				style={{
					flex: 1,
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					justifyContent: "center",
					padding: 30,
					textAlign: "center",
					position: "relative",
				}}
			>
				<img
					src={portadaImage}
					alt="portada"
					style={{
						width: 300,
						height: 300,
						objectFit: "cover",
						zIndex: 100,
					}}
				/>
				<div
					style={{
						textAlign: "center",
						zIndex: 102,
						marginTop: "-55px",
						overflow: "hidden",
						width: "100%",
						height: "180px",
						position: "relative",
					}}
				>
					<svg
						width="100%"
						height="180"
						viewBox="0 0 600 180"
						preserveAspectRatio="xMidYMid meet"
						style={{ fontFamily: "'Titan One', cursive", display: "block" }}
					>
						<text
							x="300"
							y="75"
							textAnchor="middle"
							dominantBaseline="middle"
							fontFamily="'Titan One', cursive"
							fontSize="80"
							fill={fill1}
							stroke={stroke1}
							strokeWidth="30"
							strokeLinecap="round"
							strokeLinejoin="round"
							paintOrder="stroke"
						>
							{text1}
						</text>
						<text
							x="300"
							y="125"
							textAnchor="middle"
							dominantBaseline="middle"
							fontFamily="'Titan One', cursive"
							fontSize="40"
							fill={fill2}
							stroke={stroke2}
							strokeWidth="20"
							strokeLinecap="round"
							strokeLinejoin="round"
							paintOrder="stroke"
						>
							{text2}
						</text>
					</svg>
				</div>
				<img
					src={backgroundStickersImage}
					alt="portada"
					style={{
						width: "100%",
						height: "100%",
						position: "absolute",
						top: 0,
						right: 0,
						bottom: 0,
						left: 0,
						objectFit: "cover",
						zIndex: 100,
					}}
				/>
				<div
					style={{
						width: "100%",
						height: "100%",
						position: "absolute",
						top: 0,
						right: 0,
						bottom: 0,
						left: 0,
						backgroundColor: "black",
						zIndex: 50,
						opacity: 0.4,
					}}
				/>
				<img
					src={backgroundImage}
					alt="portada"
					style={{
						width: "100%",
						height: "100%",
						position: "absolute",
						top: 0,
						right: 0,
						bottom: 0,
						left: 0,
						objectFit: "cover",
					}}
				/>
			</div>
		</Box>
	);
};

export default Template70;
